"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPosition = void 0;
require("react");
var IconPosition;
(function (IconPosition) {
    IconPosition["Left"] = "left";
    IconPosition["Right"] = "right";
})(IconPosition = exports.IconPosition || (exports.IconPosition = {}));
